/**
 * DialogBoxYesNo – LOGOUT only (Abmelden).
 * Used in: App.js (logout confirmation).
 * Do not use for partner permission – use PartnerConfirmationYesNo instead.
 */
import React, { useEffect } from "react";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import "./DialogBoxYesNo.css";

function DialogBoxYesNo({ title, text, onClose, showLogoutIcon = true }) {
  const handleKeyPress = (event) => {
    if (event.key === "Escape") {
      onClose(false);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [onClose]);

  const handleYesClick = () => onClose(true);
  const handleNoClick = () => onClose(false);

  return (
    <div className="dialog-container">
      <div className="dialog-box dialog-box-logout">
        {showLogoutIcon && (
          <div className="dialog-box-icon">
            <LogoutOutlinedIcon />
          </div>
        )}
        <h2 className="dialog-box-title">{title}</h2>
        <p className="dialog-box-text">{text}</p>
        <div className="button-container">
          <button
            type="button"
            className="dialog-button dialog-button-primary"
            onClick={handleYesClick}
          >
            Ja
          </button>
          <button
            type="button"
            className="dialog-button dialog-button-secondary"
            onClick={handleNoClick}
          >
            Nein
          </button>
        </div>
      </div>
    </div>
  );
}

export default DialogBoxYesNo;
